export default {
  VERIFY_EMAIL_REQUEST: "[emailVerification] Verify Email Request",
  RESEND_VERIFICATION_EMAIL_REQUEST: "[emailVerification] Resend Verification Email Request",
  SET_VERIFY_EMAIL_STATUS: "[emailVerification] Set Verify Email Status",
  SET_VERIFY_STRIPE_ERROR: "[emailVerification] Set Verify Stripe Error",
  // INSERTION_PT (for script, do not remove)
};
